import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enUS } from 'date-fns/locale';

//@ts-ignore
const PeekCalendar = (props) => {
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: enUS },
        React.createElement(DatePicker, Object.assign({}, props))));
};

export { PeekCalendar, PeekCalendar as default };
